import React, { useEffect } from 'react';
/// /// EXTERNAL /// ///
// third party libraries //
import { Routes, Route, Navigate } from 'react-router-dom';
import TagManager from 'react-gtm-module';
/// /// INTERNAL /// ///
// third party libraries //
import CommonProvider from 'components/providers/CommonProvider';
// components //
import Calcs from 'components/pages/Calcs';
// utils //
import { isProduction } from 'common/utils';
import Error from 'components/pages/Error';
import EnhancedSuspense from 'components/atoms/EnhancedSuspense';
import ErrorStatus from 'utils/constants';

const App = () => {
  useEffect(() => {
    if (isProduction) {
      const GTM_ID = {
        gtmId: 'GTM-5SX4XDR',
      };
      TagManager.initialize(GTM_ID);
    }
  }, []);
  return (
    <Routes>
      <Route
        element={<CommonProvider />}
      >
        <Route exact path="/:channelID" element={<Calcs />} />
        <Route exact path="/:channelID/:POC" element={<Calcs />} />
        <Route path="/error/:status" element={<Error />} />
        <Route path="*" element={<EnhancedSuspense><Error statusProps={ErrorStatus.NOT_FOUND} /></EnhancedSuspense>} />
      </Route>
      <Route exact path="/" element={<Navigate to="/prosperia/web" />} />
    </Routes>
  );
};

export default App;
